// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

import { IS_PRODUCTION } from 'utils/envs';

import sentryConfig from './sentry.config';

if (IS_PRODUCTION) {
  Sentry.init(sentryConfig);
}
